module.exports = __webpack_public_path__ + "img/BentonSansBBVA-BookItalic.385bac72.svg";